import { Route } from '@angular/router';
import { productCategories } from './productCategory';
import { campaignTypes } from './campaign-types';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../sb-routing-enum';
import { templateGroups } from './templateGroup';
import { templateSources } from './templateSources';
import { repositories } from './repositories';

export const content: Route = {
  path: 'dataset-content',
  title: 'nav.content',
  data: {
    icon: SbIcons.megaphone,
    breadcrumb: 'nav.content',
  },
  children: [
    productCategories,
    campaignTypes,
    templateGroups,
    templateSources,
    repositories,
    { path: '', redirectTo: RoutingID.campaignTypes, pathMatch: 'full' },
  ],
};
